import { useState } from 'react'
import {
    FullScreenVideoContext,
    StorefrontPlaylist,
} from '../../context/fullScreenVideoContext'

export const FullScreenVideoContextProvider: React.FC<{
    children: React.ReactNode
}> = ({ children }) => {
    const [currentIdx, setCurrentIdx] = useState<number>(-1)
    const [currentPlaylist, setCurrentPlaylist] =
        useState<StorefrontPlaylist | null>(null)
    const [isFullScreenPlayerOpen, setIsFullScreenPlayerOpen] =
        useState<boolean>(false)
    return (
        <FullScreenVideoContext.Provider
            value={{
                currentIdx,
                setCurrentIdx,
                currentPlaylist,
                setCurrentPlaylist,
                isFullScreenPlayerOpen,
                setIsFullScreenPlayerOpen,
            }}
        >
            {children}
        </FullScreenVideoContext.Provider>
    )
}
